const localizationKeys = {
  // auth
  login: "login",
  signup: "signup",
  loginWithApple: "loginWithApple",
  loginwithGoogle: "loginwithGoogle",
  loginwithFacebook: "loginwithFacebook",
  signupwithApple: "signupwithApple",
  signupwithGoogle: "signupwithGoogle",
  signupwithFacebook: "signupwithFacebook",
  somethingWentWrongPleaseTryAgainLater:
    "somethingWentWrongPleaseTryAgainLater",
  name: "name",
  email: "email",
  password: "password",
  phone: "phone",
  rememberPassword: "rememberPassword",
  forgetPassword: "forgetPassword",
  iAgreetotheTermsConditions: "iAgreetotheTermsConditions",
  createAccount: "createAccount",
  aVerificationMailHasBeenSent: "aVerificationMailHasBeenSent",
  thePasswordHasBeenSuccessfullyChanged:
    "thePasswordHasBeenSuccessfullyChanged",
  backToHome: "backToHome",
  resetPassword: "resetPassword",
  newPassword: "newPassword",
  reEnterPassword: "reEnterPassword",
  theEmailAddressForThisAccountHasNotYetBeenVerified:
    "theEmailAddressForThisAccountHasNotYetBeenVerified",
  resendMailAgain: "resendMailAgain",
  or: "or",
  backToLogin: "backToLogin",
  sentVerification: "sentVerification",
  // home
  myBids: "myBids",
  categories: "categories",
  watchlist: "watchlist",
  faqs: "faqs",
  support: "support",
  arabic: "arabic",
  english: "english",
  sellNow: "sellNow",
  search: "search",
  registerNow: "registerNow",
  profile: "profile",
  viewDetails: "viewDetails",
  bidNow: "bidNow",
  buyNow: "buyNow",
  popularCategories: "popularCategories",
  totalBids: "totalBids",
  endingTime: "endingTime",
  bid: "bid",
  results: "results",
  seeAll: "seeAll",
  brand: "brand",
  sellingType: "sellingType",
  auction: "auction",
  comingSoon: "comingSoon",
  liveAuction: "liveAuction",
  auctionState: "auctionState",
  location: "location",
  condition: "condition",
  new: "new",
  used: "used",
  openBox: "openBox",
  price: "price",
  createAuctionNow: "createAuctionNow",
  weAreAlwaysHereToHelpYou: "weAreAlwaysHereToHelpYou",
  subscribeNowToGetNewOffersAndUpdates: "subscribeNowToGetNewOffersAndUpdates",
  writeYourMail: "writeYourMail",
  subscribe: "subscribe",
  sellingOnAllatre: "sellingOnAllatre",
  sellerCenter: "sellerCenter",
  sellForCharity: "sellForCharity",
  businessTools: "businessTools",
  createAuction: "createAuction",
  myAccount: "myAccount",
  iamBiddingOn: "iamBiddingOn",
  iHaveBought: "iHaveBought",
  bidsIHaveReceived: "bidsIHaveReceived",
  iHaveSold: "iHaveSold",
  allRightsReserved: "allRightsReserved",
  upComingAuctions: "upComingAuctions",
  days: "days",
  hrs: "hrs",
  min: "min",
  // status
  activeNow: "activeNow",
  Scheduled: "Scheduled",
  sold: "sold",
  pending: "pending",
  expired: "expired",
  cancelled: "cancelled",
  blocked: "blocked",
  // Breadcrumb
  home: "home",
  productDetails: "productDetails",
  auctionDetails: "auctionDetails",
  shippingDetails: "shippingDetails",
  paymentDetails: "paymentDetails",
  myAuctions: "myAuctions",
  activeAuctions: "activeAuctions",
  scheduledAuctions: "scheduledAuctions",
  soldAuctions: "soldAuctions",
  pendingAuctions: "pendingAuctions",
  expiredAuctions: "expiredAuctions",
  // create auctions
  drafts: "drafts",
  proceed: "proceed",
  successDelete: "successDelete",
  errorDelete: "errorDelete",
  areYouSureYouWantToDeleteThisDraft: "areYouSureYouWantToDeleteThisDraft",
  cancel: "cancel",
  yesDelete: "yesDelete",
  locationIsRequired: "locationIsRequired",
  inOrderToFinishTheProcedureWeHaveToGetAccessTo:
    "inOrderToFinishTheProcedureWeHaveToGetAccessTo",
  yourLocationYouCanManageThemLater: "yourLocationYouCanManageThemLater",
  manageYouAddresses: "manageYouAddresses",
  country: "country",
  city: "city",
  address: "address",
  addressLabel: "addressLabel",
  zipCode: "zipCode",
  successAddLocatons: "successAddLocatons",
  add: "add",
  selectCountry: "selectCountry",
  selectCity: "selectCity",
  wirteYourAddress: "wirteYourAddress",
  exHome: "exHome",
  enterPostalZipCode: "enterPostalZipCode",
  // product details
  itemDetails: "itemDetails",
  itemName: "itemName",
  category: "category",
  subCategory: "subCategory",
  itemDescription: "itemDescription",
  writeItemDescription: "writeItemDescription",
  addMedia: "addMedia",
  from3upto5photos: "from3upto5photos",
  itemCondition: "itemCondition",
  saveAsDraft: "saveAsDraft",
  next: "next",
  // auction details
  quickAuction: "quickAuction",
  maximumDurationMustBeDay: "maximumDurationMustBeDay",
  durationMoreThanOneDayFromStartingDate:
    "durationMoreThanOneDayFromStartingDate",
  longAuction: "longAuction",
  Hrs: "Hrs",
  auctionDuration: "auctionDuration",
  scheduleBid: "scheduleBid",
  optional: "optional",
  unlessStartTimeAndDateAreChosenYourListingBecomesActiveImmediately:
    "unlessStartTimeAndDateAreChosenYourListingBecomesActiveImmediately",
  startDate: "startDate",
  time: "time",
  pricing: "pricing",
  minimumPrice: "minimumPrice",
  purchasingPrice: "purchasingPrice",
  minimum30MoreThanStartingBid: "minimum30MoreThanStartingBid",
  purchasingPriceMustBeMoreThanOrEqual30OfMinimumPrice:
    "purchasingPriceMustBeMoreThanOrEqual30OfMinimumPrice",
  // shiping details
  locationDetails: "locationDetails",
  addAddress: "addAddress",
  // paymemt details
  paymentMethod: "paymentMethod",
  // profile
  online: "online",
  profileSettings: "profileSettings",
  logout: "logout",
  completeYourProfileToMakeYourActionsEasier:
    "completeYourProfileToMakeYourActionsEasier",
  completeNowMasg: " completeNowMasg",
  completeNow: " completeNow",
  personalDetails: "personalDetails",
  editPhoto: "editPhoto",
  uploadPhoto: "uploadPhoto",
  dropYourPhotoHereToInstantlyUploadIt: "dropYourPhotoHereToInstantlyUploadIt",
  save: "save",
  selectAfile: "selectAfile",
  userName: "userName",
  changePassword: "changePassword",
  editPassword: "editPassword",
  oldPassword: "oldPassword",
  edit: "edit",
  editUserName: "editUserName",
  contactInfo: "contactInfo",
  eMail: "eMail",
  verified: "verified",
  phoneNumber: "phoneNumber",
  editPhoneNumber: "editPhoneNumber",
  loginService: "loginService",
  loginServiceMaseg: "loginServiceMaseg",
  connected: "connected",
  connectedWithApple: "connectedWithApple",
  connectWithGoogle: "connectWithGoogle",
  connectWithFacebook: "connectWithFacebook",
  addressBook: "addressBook",
  addressBookmasg: "addressBookmasg",
  the: "the",
  delete: "delete",
  makeDefault: "makeDefault",
  default: "default",
  yourWatchlist: "yourWatchlist",
  thereAreNoWatchlistYet: " thereAreNoWatchlistYet",
  // myauctions
  createNow: "createNow",
  thereAreNoAuctionsCurrentlyMakeYourFirstAuctionRightAway:
    "thereAreNoAuctionsCurrentlyMakeYourFirstAuctionRightAway",
  totalAuctions: "totalAuctions",
  total: "total",
  active: "active",
  totalActive: "totalActive",
  oppsActive: "oppsActive",
  youCanCreateOne: "youCanCreateOne",
  lastPrice: "lastPrice",
  startingPrice: "startingPrice",
  startingDate: " startingDate",
  pendingDeposit: "pendingDeposit",
  purchasePrice: "purchasePrice",
  endingDate: "endingDate",
  totalScheduled: "totalScheduled",
  opsScheduled: "opsScheduled",
  totalDraft: "totalDraft",
  opsDraft: "opsDraft",
  totalSold: "totalSold",
  opsSold: "opsSold",
  totalPending: "totalPending",
  opsPending: "opsPending",
  totalExpired: "totalExpired",
  totalCancelled: "totalCancelled",
  opsExpired: "opsExpired",
  //  details
  reviews: "reviews",
  timeLeft: "timeLeft",
  submitBid: "submitBid",
  description: "description",
  series: "series",
  bidderName: "bidderName",
  biddingEndingTime: "biddingEndingTime",
  lastBidAmount: "lastBidAmount",
  totalBidders: "totalBidders",
  biddingTime: "biddingTime",
  bidAmount: "bidAmount",
  startingBidAmount: "startingBidAmount",
  currentBid: "currentBid",
  submitValueIsRequiredAndMustBeBiggerThanCurrentBid:
    "submitValueIsRequiredAndMustBeBiggerThanCurrentBid",
  yourAddNewSubmitValueSuccessfully: "yourAddNewSubmitValueSuccessfully",
  congratulationsOnYourFirstBid: "congratulationsOnYourFirstBid",
  editBid: "editBid",
  pay: "pay",
  deposit: "deposit",
  YouAreAboutToPlaceBidFor: " YouAreAboutToPlaceBidFor",
  InThisAuctionPleaseNoticeThatYouWillNeedToPayA:
    "InThisAuctionPleaseNoticeThatYouWillNeedToPayA",
  ofThePriceAsADepositOnlyOnceSoYouCanFreelyEnjoyBidding:
    "ofThePriceAsADepositOnlyOnceSoYouCanFreelyEnjoyBidding",
  endingPrice: "endingPrice",
  viewAll: "viewAll",
  // tab details
  shippingPolicy: "shippingPolicy",
  returnPolicy: "returnPolicy",
  payment: "payment",
  feedback: "feedback",
  aboutTheBrand: "aboutTheBrand",
  // err
  required: "required",
  makeSureThatYouChooseItemConditionValue:
    "makeSureThatYouChooseItemConditionValue",
  makeSureThatYouChooseAtLeastThreeOrMorePhotos:
    "makeSureThatYouChooseAtLeastThreeOrMorePhotos",
  oops: "oops",
  mustOneUppercaseOneLowercaseOneNumberAndOneSpecialCaseCharacter:
    "mustOneUppercaseOneLowercaseOneNumberAndOneSpecialCaseCharacter",
  notMatch: "notMatch",
  // sucsess
  thisAuctionDeleteFromWatchListBeenSuccessfully:
    "thisAuctionDeleteFromWatchListBeenSuccessfully",
  thisAuctionAddToWatchListBeenSuccessfully:
    "thisAuctionAddToWatchListBeenSuccessfully",
  thePasswordHasBeenEditSuccessfully: "thePasswordHasBeenEditSuccessfully",
  hasBeenDeleteSuccessfully: "hasBeenDeleteSuccessfully",
  hasBeenMakeDefaultSuccessfully: "hasBeenMakeDefaultSuccessfully",
  thePhoneNumberHasBeenEditSuccessfully:
    "thePhoneNumberHasBeenEditSuccessfully",
  nameHasBeenEditSuccessfully: "nameHasBeenEditSuccessfully",
  uploadImageHasbeenSuccessfully: "uploadImageHasbeenSuccessfully",
  yourAuctionSaveAsDraftedSuccess: "yourAuctionSaveAsDraftedSuccess",
  yourAuctionIsCreatedSuccess: "yourAuctionIsCreatedSuccess",
  makeSureThatYouChooseTheAuctionLocationOrCreateAnotherOne:
    "makeSureThatYouChooseTheAuctionLocationOrCreateAnotherOne",
  //messages
  YouSuccessfullyCancelledTheAuction: "YouSuccessfullyCancelledTheAuction",
  //wallet
  WalletBalance: "WalletBalance",
  AccountBalance: "AccountBalance",
  Withdraw: "Withdraw",
  Date: "Date",
  Withdrawals: "Withdrawals",
  Deposits: "Deposits",
  Balance: "Balance",
  Description: "Description",
  adminObjections: "adminObjections",
  product: "product",
  noResultsFound: "noResultsFound",
  objectionBy: "objectionBy",
  repliedBy: "repliedBy",
  repliedOn: "repliedOn",
  reason: "reason",
  documents: "documents",
  status: "status",
  date: "date",
  actions: "actions",
  noFiles: "noFiles",
  inProgress: "inProgress",
  solved: "solved",
  userComplaints: "userComplaints",
  complainingUser: "complainingUser",
  seller: "seller",
  complaint: "complaint",
  complaintStatus: "complaintStatus",
  actionStatus: "actionStatus",
  complaintDetails: "complaintDetails",
  sellerDetails: "sellerDetails",
  winnerDetails: "winnerDetails",
  mediaGalleryOfComplaints: "mediaGalleryOfComplaints",
  noMediaAvailable: "noMediaAvailable",
  close: "close",
  reply: "reply",
  finalDecision: "finalDecision",
  submitFinalDecision: "submitFinalDecision",
  adminFinalDecision: "adminFinalDecision",
  finalDecisionFiles: "finalDecisionFiles",
  noFinalDecision: "noFinalDecision",
  finalDecisionSubmitted: "finalDecisionSubmitted",
};

export default localizationKeys;
